export default __webpack_public_path__ + "images/gradient_bg-CUNLt.jpg";